import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import type { SkipReviewReport } from 'bundles/peer/types/Reviews';

const onDemandPeerSkipReviewsApi = API('/api/onDemandPeerSkipReviews.v1', {
  type: 'rest',
});

export const skipReview = ({
  userId,
  courseId,
  itemId,
  submissionId,
  report,
}: {
  userId: number;
  courseId: string;
  itemId: string;
  submissionId: string;
  report: SkipReviewReport;
}): Q.Promise<void> => {
  const uri = new URI();

  const data = {
    userPeerSubmissionId: `${userId}~${courseId}~${itemId}~${submissionId}`,
    reason: {
      typeName: report.reason,
      definition: {
        explanation: report.evidence,
      },
    },
  };

  return Q(onDemandPeerSkipReviewsApi.post(uri.toString(), { data }));
};
